(function () {
  var ARABIC_DIACRITICS = /[ً-ْٰـ]/g; // harakat, dagger alif, tatweel
  var ALEF_VARIANTS = /[آأإ]/g; // آ أ إ -> ا

  function normalizeArabicQuery(value) {
    return value
      .replace(ARABIC_DIACRITICS, '')
      .replace(ALEF_VARIANTS, 'ا')
      .replace(/\s+/g, ' ');
  }

  function normalizeInPlace(input) {
    var normalized = normalizeArabicQuery(input.value);
    if (normalized === input.value) return;

    var lengthDelta = input.value.length - normalized.length;
    var caret = input.selectionStart;
    input.value = normalized;

    if (typeof caret === 'number') {
      var newCaret = Math.max(0, caret - lengthDelta);
      input.setSelectionRange(newCaret, newCaret);
    }
  }

  document.addEventListener(
    'input',
    function (event) {
      var target = event.target;
      if (target && target.tagName === 'INPUT' && target.name === 'q') {
        normalizeInPlace(target);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      var input = form.querySelector('input[name="q"]');
      if (!input || !input.value) return;
      input.value = normalizeArabicQuery(input.value).trim();
    },
    true
  );
})();
